import {
  Briefcase,
  Building2,
  FlaskConical,
  Plane,
  Rocket,
  ShoppingBag,
  type LucideIcon,
} from 'lucide-react';
import type { PartnerRole } from '@nx/domain';
import { DEFAULT_PROFILE_ROLE_TYPE, normalizeProfileRoleType } from '@nx/domain';
import type { TranslationKey } from '@nx/i18n';

export interface PartnerRoleDisplayOption {
  value: PartnerRole;
  profileLabelKey: TranslationKey;
  signupTitleKey: TranslationKey;
  signupDescKey: TranslationKey;
  icon: LucideIcon;
}

export const PARTNER_ROLE_DISPLAY: PartnerRoleDisplayOption[] = [
  {
    value: 'customer',
    profileLabelKey: 'profile.role.customer',
    signupTitleKey: 'signup.role.customer',
    signupDescKey: 'signup.role.customerDesc',
    icon: ShoppingBag,
  },
  {
    value: 'travelAgency',
    profileLabelKey: 'profile.role.travelAgency',
    signupTitleKey: 'signup.role.travelAgency',
    signupDescKey: 'signup.role.travelAgencyDesc',
    icon: Plane,
  },
  {
    value: 'eventOrganizer',
    profileLabelKey: 'profile.role.eventOrganizer',
    signupTitleKey: 'signup.role.eventOrganizer',
    signupDescKey: 'signup.role.eventOrganizerDesc',
    icon: Rocket,
  },
  {
    value: 'facilityProvider',
    profileLabelKey: 'profile.role.facilityProvider',
    signupTitleKey: 'signup.role.facilityProvider',
    signupDescKey: 'signup.role.facilityProviderDesc',
    icon: Building2,
  },
  {
    value: 'serviceProvider',
    profileLabelKey: 'profile.role.serviceProvider',
    signupTitleKey: 'signup.role.serviceProvider',
    signupDescKey: 'signup.role.serviceProviderDesc',
    icon: Briefcase,
  },
  {
    value: 'researchPartner',
    profileLabelKey: 'profile.role.researchPartner',
    signupTitleKey: 'signup.role.researchPartner',
    signupDescKey: 'signup.role.researchPartnerDesc',
    icon: FlaskConical,
  },
];

const DEFAULT_ROLE_DISPLAY =
  PARTNER_ROLE_DISPLAY.find((opt) => opt.value === DEFAULT_PROFILE_ROLE_TYPE) ??
  PARTNER_ROLE_DISPLAY[0];

export function getPartnerRoleDisplay(role: PartnerRole | string | null | undefined) {
  const normalized = normalizeProfileRoleType(role);
  return PARTNER_ROLE_DISPLAY.find((opt) => opt.value === normalized) ?? DEFAULT_ROLE_DISPLAY;
}
